var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vuestic-collapse"},[_c('div',{staticClass:"vuestic-collapse__header",class:{
      'vuestic-collapse__header--no-header': _vm.noHeader,
    },on:{"click":function($event){return _vm.onHeaderClick()}}},[(_vm.noHeader)?[_vm._t("header")]:_c('button',{staticClass:"vuestic-collapse__header__button btn btn-primary btn-lg"},[_vm._t("header")],2)],2),_c('div',{ref:"collapseBody",staticClass:"vuestic-collapse__body"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }